<template>
  <ul class="search-summary">
    <li class="search-summary__item">
      <svg
        v-if="searchSessionStatus === 'search'"
        class="search-summary__reset"
        width="10"
        height="10"
        @click="onReset"
      >
        <title>Очистить запрос</title>
        <use xlink:href="#plus" />
      </svg>

      <strong class="search-summary__label">
        {{ `${searchSessionStatus ? titles[searchSessionStatus] : ''}` }}
      </strong>

      <span>{{ `${searchQuery.text?'«'+searchQuery.text+'»':''}` }}</span>
    </li>

    <li class="search-summary__item">
      <svg
        v-if="isContent"
        class="search-summary__reset"
        width="10"
        height="10"
        @click="onFilterReset"
      >
        <title>Очистить фильтр</title>
        <use xlink:href="#plus" />
      </svg>
      <strong class="search-summary__label">Фильтр:</strong>
      <span v-html="filtersContent"></span>
    </li>

    <li class="search-summary__item">
      <strong class="search-summary__label">
        {{ `${searchResults.total ? 'Найдено:' : ''}` }}
      </strong>

      <template>
        <span v-if="searchResults.total">
          {{
            $options.filters.pluralForm(
              searchResults.total,
              'документ',
              'документа',
              'документов',
              true
            )
          }}
        </span>
      </template>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex';

const TAGS = {
  availableOnly: 'Только доступные документы',
  classifiers: 'классификаторы',
  checklists: 'перечни',
  statuses: 'статус документа',
  types: 'индексы',
  organizations: 'утвержден',
  dates: 'по датам',
  addedInBase: 'добавленные в базу',
  designers: 'разработан'
};
const TITLES = {
  search: 'Запрос',
  checklists: 'Информационный поиск по перечням',
  classifiers: 'Информационный поиск по классификаторам'
};

export default {
  data() {
    return {
      tags: TAGS,
      titles: TITLES
    };
  },
  computed: {
    ...mapGetters([
      'searchQuery',
      'searchSessionStatus',
      'filtersState',
      'searchResults'
    ]),
    isContent() {
      let isContent = false;

      Object.keys(this.filtersState).forEach(key => {
        if (Array.isArray(this.filtersState[key])) {
          if (this.filtersState[key].length) isContent = true;
        } else {
          if (this.filtersState[key]) isContent = true;
        }
      });

      return isContent;
    },
    filtersContent() {
      if (this.searchSessionStatus === 'classifiers')
        return this.makeValueText(this.filtersState.classifiers);
      if (this.searchSessionStatus === 'checklists')
        return this.makeValueText(this.filtersState.checklists);
      if (this.searchSessionStatus === 'search') return this.filterTagsText();

      return '';
    }
  },

  methods: {
    filterTagsText() {
      let filterText = [];

      Object.keys(this.tags).forEach(key => {
        if (Array.isArray(this.filtersState[key])) {
          /*if (key === "dates") {
            let datesFiltersText = "";
            let modifiedFrom = this.filtersState["modifiedFrom"];
            let modifiedTo = this.filtersState["modifiedTo"];
            if (modifiedFrom != "" || modifiedTo != "") {
              datesFiltersText = "Измененные ";

            }
          }*/
          if (this.filtersState[key].length) {
            if (key === "dates") {
              let newFiltersState = this.filterStateCorrect(this.filtersState[key]);
              filterText.push(
                `<em>${this.tags[key]}</em> ${this.makeValueText(newFiltersState)
                }`
              );
            }
            else
              filterText.push(
                `<em>${this.tags[key]}</em> ${this.makeValueText(
                  this.filtersState[key])
                }`
              );
          }
        } 
        else {
          if (this.filtersState[key]) {
            if (key === "addedInBase") {
              filterText.push(
                `<em>${this.tags[key]}</em> ${this.makeValueText(
                  this.filtersState[key])
                }`
              );
            }
            else
              filterText.push(this.makeValueText(this.tags[key]));
          }
        }
      });
      let str = filterText.join('; ');
      return filterText.join('; ');
    },
    // метод корректировки массива FiltersState
    // объединяет строки с одинаковым значением типа даты и удаляет лишние строки
    // Например, из 2-х строк "Измененные с ..."  "Измененные по ..."
    // делает одну строку "Измененные с ... по ..."
    filterStateCorrect(FiltersState) {
      let newFiltersState = [];
      for(var i1 = 0, len = FiltersState.length; i1 < len; ++i1)
        newFiltersState[i1] = FiltersState[i1];
      let i = 0;
      let len1 = newFiltersState.length;
      do {
        let i1 = newFiltersState[i].indexOf(" ");
        let nameDate = newFiltersState[i].substring(0, i1);
        let ind = newFiltersState.findIndex(item => item.indexOf(nameDate) != -1 && item != newFiltersState[i]);
        if (ind != -1) {
          let from = (newFiltersState[i].substr(i1 + 1, 1) === "с");
          let i2 = newFiltersState[i].indexOf(" ", i1 + 1);
          let date1 = newFiltersState[i].substring(i2 + 1);
          i2 = newFiltersState[ind].indexOf(" ", i1 + 1);
          let date2 = newFiltersState[ind].substring(i2 + 1);
          newFiltersState[i] = nameDate + (from ? " с " + date1 + " по " + date2 :
            " с " + date2 + " по " + date1);
          newFiltersState.splice(ind, 1);
          len1--;
        }
        i++;
      } while (i < len1);
      return newFiltersState;
    },
    makeValueText(val) {
      let myTrim = this.$options.filters.truncateText;
      let text = Array.isArray(val)
        ? val.map(str => myTrim(str, 100)).join('», «')
        : myTrim(val, 100);

      return text ? `«${text}»` : '';
    },
    onReset() {
      this.$store.dispatch('resetRequest');
    },
    onFilterReset() {
      this.$store.dispatch('resetFilters');
    }
  }
};
</script>
